export default "__VITE_ASSET__3avEQNvf__"